'use client';

import { useParams } from 'react-router-dom';

import { useOptionalSetupProcessorEmbedProcessorId } from '@/components/setup/experience/SetupProcessorEmbedContext';

export function useProcessorEditId(): string {
  const embedProcessorId = useOptionalSetupProcessorEmbedProcessorId();
  const { id } = useParams();
  const resolved = embedProcessorId ?? id;

  if (!resolved) {
    throw new Error('Processor id is required');
  }

  return resolved;
}
